<template>
	<div class="opblock"
		 :class="containerClassName"
		 id="operations-default-get_accounts"
	>
		<div class="opblock-summary" :class="summaryClassName" @click="editMode = !editMode">
			<span class="opblock-summary-method">{{ endpoint.method }}</span>
			<span class="opblock-summary-path">
					<a class="nostyle">
						<span>{{ endpoint.endpoint }}</span>
					</a>
       			</span>
			<div class="opblock-summary-description"></div>
		</div>
		<v-container grid-list-md text-xs-right v-if="editMode">
			<v-form ref="form" class="xs12">
				<v-layout row wrap>
					<template>
						<v-flex xs12 md3>
							<v-select light lazy filled v-model="endpointDetail.method" :items="methodOptions"
									  :label="$t('projects.routes.method')"></v-select>
						</v-flex>
						<v-flex xs12 md9>
							<v-text-field light lazy filled v-model="endpointDetail.endpoint"
										  :label="$t('projects.routes.endpoint')"></v-text-field>
						</v-flex>
					</template>
				</v-layout>
				<v-layout row wrap>
					<template>
						<v-flex xs12 md3>
							<v-checkbox
								v-model="endpointDetail.requiresAuthentication"
								:label="$t('projects.routes.requires-authentication')"
								hide-details
							></v-checkbox>
						</v-flex>
						<v-flex xs12 md9>
							<v-select light lazy filled multiple
									  v-model="endpointDetail.requiredRoles"
									  :items="roles"
									  item-text="name"
									  item-value="_id"
									  :label="$t('projects.routes.required-roles')"></v-select>
						</v-flex>
					</template>
				</v-layout>
			</v-form>
			<v-btn color="primary"
				   :loading="isSaving"
				   @click="save()">
				{{ $t('save') }}
			</v-btn>
			<v-btn class="ma-1" color="secondary" v-if="isNewEndpoint"
				   @click.prevent="showConfirmDeleteDialog = true">
				{{ $t('remove') }}
			</v-btn>
		</v-container>
		<confirm-delete-dialog v-model="showConfirmDeleteDialog"
							   :body="$t('confirm-delete.body-subject', {subject: endpoint.endpoint})"
							   @remove="removeEndpoint"></confirm-delete-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import ConfirmDeleteDialog from '@/components/dialogs/confirm-delete-dialog';

export default {
	name: 'RouteListItem',
	components: { ConfirmDeleteDialog },
	props: {
		endpoint: {
			type: Object,
		}
	},
	data() {
		return {
			showConfirmDeleteDialog: false,
			methodOptions: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
			editMode: false,
			endpointDetail: {}
		};
	},
	computed: {
		...mapState({
			isSaving: state => state.project.isSavingProject,
			roles: state => state.role.roles
		}),
		summaryClassName() {
			return `opblock-summary-${this.endpoint.method.toLowerCase()}`;
		},
		containerClassName() {
			return `opblock-${this.endpoint.method.toLowerCase()}`;
		},
		isNewEndpoint() {
			return !!this.endpointDetail._id;
		}
	},
	mounted() {
		this.endpointDetail = JSON.parse(JSON.stringify(this.endpoint));
	},
	methods: {
		save() {
			this.$emit('save', this.endpointDetail);
		},
		removeEndpoint() {
			this.$emit('removeEndpoint', this.endpointDetail._id);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/styles/colors";
@import "swagger";

.cards {
	background-color: $background-grey !important;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 250px;
	height: 250px;
	margin: 10px;
	text-align: center;

	&:hover {
		background-color: $light-grey !important;
	}
}

.remove-button {
	position: absolute;
	top: 5px;
	right: 5px;
}
</style>
